import React, { useState, useRef } from 'react';
import { FlatSprout } from '../components/FlatSprout';
import { FlatForest } from '../components/FlatForest';
import { QrCode, Globe, Leaf } from 'lucide-react';
interface Props {
  onNavigateToMatch: () => void;
  onScanPress: () => void;
}
export function TreeHome({
  onNavigateToMatch,
  onScanPress
}: Props) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
    setIsDragging(true);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientX - startX.current;
    if (activeSlide === 0 && diff > 0) {
      setDragOffset(diff * 0.3);
    } else if (activeSlide === 1 && diff < 0) {
      setDragOffset(diff * 0.3);
    } else {
      setDragOffset(diff);
    }
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
    if (dragOffset < -60 && activeSlide === 0) {
      setActiveSlide(1);
    } else if (dragOffset > 60 && activeSlide === 1) {
      setActiveSlide(0);
    }
    setDragOffset(0);
  };
  const handleMouseDown = (e: React.MouseEvent) => {
    startX.current = e.clientX;
    setIsDragging(true);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    const diff = e.clientX - startX.current;
    if (activeSlide === 0 && diff > 0) {
      setDragOffset(diff * 0.3);
    } else if (activeSlide === 1 && diff < 0) {
      setDragOffset(diff * 0.3);
    } else {
      setDragOffset(diff);
    }
  };
  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);
    if (dragOffset < -60 && activeSlide === 0) {
      setActiveSlide(1);
    } else if (dragOffset > 60 && activeSlide === 1) {
      setActiveSlide(0);
    }
    setDragOffset(0);
  };
  const translateX = -activeSlide * 100;
  const dragPercent = dragOffset / window.innerWidth * 100;
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden relative" data-id="element-551">
      {/* Fixed Header */}
      <div className="z-10 bg-[#0D0D0D] border-b border-[#2A2A2A]/50 px-6 pt-10 pb-4 flex items-center justify-between flex-shrink-0" data-id="element-552">
        <h1 className="font-medium text-white text-[17px] tracking-tight" data-id="element-553">
          Impatto
        </h1>
        <button onClick={onScanPress} className="bg-transparent border border-[#C5D82D] rounded-full px-4 py-1.5 flex items-center gap-2 active:scale-95 transition-all duration-200" data-id="element-554">
          <QrCode className="w-4 h-4 text-[#C5D82D]" strokeWidth={2.5} data-id="element-555" />
          <span className="text-[12px] font-medium text-white" data-id="element-556">Scan</span>
        </button>
      </div>

      {/* Dot Indicators */}
      <div className="flex justify-center gap-2 pt-4 pb-2 flex-shrink-0" data-id="element-557">
        <button onClick={() => setActiveSlide(0)} className={`h-1.5 rounded-full transition-all duration-300 ${activeSlide === 0 ? 'w-6 bg-[#C5D82D]' : 'w-1.5 bg-[#2A2A2A]'}`} data-id="element-558" />
        <button onClick={() => setActiveSlide(1)} className={`h-1.5 rounded-full transition-all duration-300 ${activeSlide === 1 ? 'w-6 bg-[#C5D82D]' : 'w-1.5 bg-[#2A2A2A]'}`} data-id="element-559" />
      </div>

      {/* Slides Container */}
      <div className="flex-1 overflow-hidden relative min-h-0" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} data-id="element-560">
        <div className="flex h-full" style={{
        transform: `translateX(calc(${translateX}% + ${dragPercent}%))`,
        transition: isDragging ? 'none' : 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        cursor: isDragging ? 'grabbing' : 'grab'
      }} data-id="element-561">
          {/* SLIDE 1: Il tuo impatto */}
          <div className="w-full flex-shrink-0 h-full flex flex-col" data-id="element-562">
            <div className="flex flex-col items-center px-6 pt-4 flex-shrink-0" data-id="element-563">
              <div className="flex items-center gap-2 mb-3" data-id="element-564">
                <Leaf className="w-4 h-4 text-[#888888]" data-id="element-565" />
                <h2 className="text-[12px] text-[#888888] uppercase tracking-[0.25em]" data-id="element-566">
                  Il tuo impatto
                </h2>
              </div>
              <div className="flex flex-col items-center" data-id="element-567">
                <span className="text-[48px] font-extralight text-[#C5D82D] tracking-tighter leading-none" data-id="element-568">
                  4
                </span>
                <span className="text-[11px] text-[#888888] mt-1.5" data-id="element-569">
                  connessioni
                </span>
              </div>
            </div>

            {/* IL GERMOGLIO — fills remaining space */}
            <div className="flex-1 flex items-center justify-center min-h-0 px-6" data-id="element-570">
              <FlatSprout className="w-auto h-full max-h-full" data-id="element-571" />
            </div>
          </div>

          {/* SLIDE 2: Impatto della community */}
          <div className="w-full flex-shrink-0 h-full overflow-y-auto" data-id="element-572">
            <div className="flex flex-col items-center px-6 pt-4 pb-4" data-id="element-573">
              <div className="flex items-center gap-2 mb-6" data-id="element-574">
                <Globe className="w-4 h-4 text-[#888888]" data-id="element-575" />
                <h2 className="text-[12px] text-[#888888] uppercase tracking-[0.25em]" data-id="element-576">
                  Impatto della community
                </h2>
              </div>

              {/* Stats */}
              <div className="flex items-center gap-6 mb-8" data-id="element-577">
                <div className="flex flex-col items-center" data-id="element-578">
                  <span className="text-[44px] font-extralight text-[#C5D82D] tracking-tighter leading-none" data-id="element-579">
                    847
                  </span>
                  <span className="text-[11px] text-[#888888] mt-1.5" data-id="element-580">
                    connessioni
                  </span>
                </div>
                <div className="w-[1px] h-12 bg-[#2A2A2A]" data-id="element-581" />
                <div className="flex flex-col items-center" data-id="element-582">
                  <span className="text-[44px] font-extralight text-[#C5D82D] tracking-tighter leading-none" data-id="element-583">
                    12
                  </span>
                  <span className="text-[11px] text-[#888888] mt-1.5" data-id="element-584">
                    alberi
                  </span>
                </div>
                <div className="w-[1px] h-12 bg-[#2A2A2A]" data-id="element-585" />
                <div className="flex flex-col items-center" data-id="element-586">
                  <span className="text-[44px] font-extralight text-[#C5D82D] tracking-tighter leading-none" data-id="element-587">
                    320
                  </span>
                  <span className="text-[11px] text-[#888888] mt-1.5" data-id="element-588">
                    partecipanti
                  </span>
                </div>
              </div>

              {/* Forest Visual */}
              <div className="flex flex-col items-center mb-6" data-id="element-589">
                <FlatForest data-id="element-590" />
              </div>

              <div className="w-10 h-[1px] bg-[#2A2A2A] mb-6" data-id="element-591" />

              <p className="text-[14px] text-[#555555] text-center max-w-[260px] leading-relaxed" data-id="element-592">
                Insieme stiamo costruendo una foresta. Ogni connessione avvicina
                la community a un nuovo albero piantato a Roma.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Bottom CTA */}
      <div className="flex-shrink-0 px-6 py-4 bg-[#0D0D0D] border-t border-[#2A2A2A]/50" data-id="element-593">
        <button onClick={onNavigateToMatch} className="w-full bg-transparent border border-[#C5D82D] text-white rounded-full py-3.5 font-medium text-base transition-all duration-200 active:scale-[0.98]" data-id="element-594">
          {activeSlide === 0 ? 'Vai alle connessioni' : 'Contribuisci anche tu'}
        </button>
      </div>
    </div>;
}